import styles from "../styles/locations";
import React, { useEffect, useState } from "react";
import Navbar from "../components/navbar";
import Radium from "radium";
import { useQuery, useQueryClient } from "react-query";
import { dateEnToFr } from "../utils/utils";
import { getMe } from "../api/users";
import { useNavigate, useParams } from "react-router-dom";
import { getReservation, toggleDeposit, sendClientEmail } from "../api/reservations";
import Header from "../components/header";
import StatusBadge from "../components/StatusBadge";
import DepositBadge from "../components/DepositBadge";
import Loader from "../components/Loader";
import ReservationSkeleton from "../components/ReservationSkeleton";
import InfoCard from "../components/InfoCard";
import { Modal, Button } from "react-bootstrap";
import { toast } from "../components/toast";
import colors from "../theme/colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faCalendarDays,
  faUser,
  faCreditCard,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";

// Ligne "label / valeur" alignée pour la présentation des données.
const Row = ({ label, value }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      gap: 10,
      padding: "3px 0",
    }}
  >
    <span style={{ color: colors.neutral, whiteSpace: "nowrap" }}>{label}</span>
    <span
      style={{
        color: colors.text,
        fontWeight: 600,
        textAlign: "right",
        overflowWrap: "anywhere",
        minWidth: 0,
      }}
    >
      {value}
    </span>
  </div>
);

function Reservation() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: reservation } = useQuery("reservation", () =>
    getReservation(id)
  );

  const queryClient = useQueryClient();
  const { data: me } = useQuery("me", () => getMe(navigate));

  const handleToggleDeposit = async () => {
    await toggleDeposit(id);
    queryClient.invalidateQueries("reservation");
  };

  const [showEmailConfirm, setShowEmailConfirm] = useState(false);

  const handleSendClientEmail = async () => {
    setShowEmailConfirm(false);
    try {
      const result = await sendClientEmail(id);
      toast.success(result.message || "Email envoyé");
      queryClient.invalidateQueries("reservation");
    } catch (e) {
      toast.error(e.response?.data?.message || "Erreur lors de l'envoi");
    }
  };

  const iconPortail = (portail) => {
    switch (portail) {
      case "www.airbnb.com":
        return (
          <img
            src={"/assets/icons/portails/airbnb.png"}
            style={styles.iconPortailAirbnb}
            alt="Airbnb"
            title={"Airbnb"}
          />
        );
      case "www.booking.com":
        return (
          <img
            src={"/assets/icons/portails/booking.png"}
            style={styles.iconPortailBooking}
            alt="Booking"
            title={"Booking"}
          />
        );
      case "www.kyrnovarent.com":
        return (
          <img
            src={"/assets/icons/portails/kyrnovarent.png"}
            style={styles.iconPortailKyrnova}
            alt="KyrnovaRent"
            title={"KyrnovaRent"}
          />
        );
      case "www.vrbo.com":
        return (
          <img
            src={"/assets/icons/portails/vrbo.png"}
            style={styles.iconPortailVrbo}
            alt="Vrbo"
            title={"Vrbo"}
          />
        );
      case "www.holidu.com":
        return (
          <img
            src={"/assets/icons/portails/holidu.png"}
            style={styles.iconPortailHolidu}
            alt="Holidu"
            title={"Holidu"}
          />
        );
      case "Homes & Villas by Marriott International":
        return (
          <img
            src={"/assets/icons/portails/homes-and-villas.png"}
            style={styles.iconPortailHomes}
            alt="Homes & Villas"
            title={"Homes & Villas"}
          />
        );
      case "www.hometogo.de":
        return (
          <img
            src={"/assets/icons/portails/home-to-go.png"}
            style={styles.iconPortailHomes}
            alt="HomeToGo"
            title={"HomeToGo"}
          />
        );
      default:
        return (
          <img
            src={"/assets/icons/portails/kyrnovarent.png"}
            style={styles.iconPortailKyrnova}
            alt="Autre"
            title={"Autre"}
          />
        );
    }
  };

  return (
    <div style={styles.page}>
      <Header />
      <Navbar page={"reservations"} me={me} />

      <Modal show={showEmailConfirm} onHide={() => setShowEmailConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Email espace client</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Envoyer l'email espace client
          {reservation?.client_object?.email ? ` à ${reservation.client_object.email}` : ""} ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEmailConfirm(false)}>
            Annuler
          </Button>
          <Button variant="primary" onClick={handleSendClientEmail}>
            Envoyer
          </Button>
        </Modal.Footer>
      </Modal>
      <div style={styles.SectionInfo}>
        <div style={styles.h1}>
          <span style={styles.h1W}>Réservation #{reservation?.id}</span>
          <span style={{ fontWeight: 300, color: colors.neutral }}>
            {" "}
            — {reservation?.property_object?.name}
          </span>
        </div>
      </div>

      <div style={styles.containerFluid}>
        <div style={styles.contentCard}>
          {!reservation && <ReservationSkeleton />}

          {reservation && (
            <>
              <div style={styles.reservation}>
                <div style={styles.imageReservation}>
                  <img
                    src={
                      reservation?.property_object?.photo_url ??
                      "/assets/images/villa.png"
                    }
                    alt="image_villa"
                    style={styles.big_image_villa}
                  />
                </div>
                <div
                  style={{
                    ...styles.infoReservation,
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                  }}
                >
                  <InfoCard icon={faHouse} title="Réservation">
                    <p style={{ margin: "0 0 8px" }}>{reservation?.property_object?.name}</p>
                    <div style={styles.divIconPortail}>
                      {iconPortail(reservation?.portail)}
                    </div>
                    {reservation?.status && (
                      <StatusBadge status={reservation.status} style={{ marginTop: 10 }} />
                    )}
                    {reservation?.deposit_paid_by_tylt && (
                      <DepositBadge
                        provider="tyllt"
                        onRemove={me?.id === 1 ? handleToggleDeposit : undefined}
                      />
                    )}
                    {reservation?.portail === 'www.airbnb.com' && (
                      <DepositBadge provider="airbnb" />
                    )}
                    {me?.id === 1 && !reservation?.deposit_paid_by_tylt && reservation?.portail !== 'www.airbnb.com' && (
                      <button
                        type="button"
                        onClick={handleToggleDeposit}
                        style={{
                          marginTop: 10,
                          padding: '6px 14px',
                          borderRadius: 7,
                          fontSize: 12,
                          fontWeight: 600,
                          color: colors.white,
                          backgroundColor: colors.success,
                          border: "none",
                          cursor: "pointer",
                        }}>
                        Marquer caution Tyllt
                      </button>
                    )}
                  </InfoCard>

                  <InfoCard icon={faCalendarDays} title="Informations de réservation">
                    <Row
                      label="Entrée"
                      value={<>{dateEnToFr(reservation?.arrival_date)} à {reservation?.checkin_schedule}</>}
                    />
                    <Row
                      label="Sortie"
                      value={<>{dateEnToFr(reservation?.departure_date)} à {reservation?.checkout_schedule}</>}
                    />
                    <Row label="Nuits" value={reservation?.nights} />
                  </InfoCard>

                  <InfoCard
                    icon={faUser}
                    title="Contact"
                    titleRight={
                      reservation?.client_info_validated_status?.validated && (
                        <span
                          style={{
                            padding: "3px 8px",
                            borderRadius: 7,
                            fontSize: 11,
                            fontWeight: 600,
                            color: colors.white,
                            backgroundColor: colors.success,
                            whiteSpace: "nowrap",
                          }}
                        >
                          <FontAwesomeIcon icon={faCheck} style={{ marginRight: 6 }} />
                          Informations validées
                        </span>
                      )
                    }
                  >
                    {reservation?.client_object?.name === "Inconnu" ||
                    reservation?.client_object?.name === "Non disponible" ? (
                      <p>Non disponible</p>
                    ) : (
                      <>
                        <Row label="Nom" value={reservation?.client_object?.name} />
                        <Row label="Téléphone" value={reservation?.client_object?.phone} />
                        <Row label="Email" value={reservation?.client_object?.email} />
                        <Row label="Adultes" value={reservation?.adults} />
                        <Row
                          label="Enfants"
                          value={
                            <>
                              {reservation?.childs}{" "}
                              {`${
                                reservation?.childs > 0
                                  ? "(" + reservation?.childs_age + ")"
                                  : ""
                              }`}
                            </>
                          }
                        />
                      </>
                    )}
                    {me?.role === 'admin' && reservation?.client_object?.email && (
                      <>
                        <button
                          type="button"
                          onClick={() => setShowEmailConfirm(true)}
                          style={{
                            marginTop: 12,
                            width: "100%",
                            boxSizing: "border-box",
                            minHeight: 32,
                            padding: "6px 14px",
                            borderRadius: 8,
                            fontSize: 12,
                            fontWeight: 600,
                            color: colors.white,
                            backgroundColor: reservation?.client_email_sent ? colors.neutral : colors.brand,
                            border: "none",
                            cursor: "pointer",
                          }}>
                          {reservation?.client_email_sent ? 'Renvoyer email espace client' : 'Envoyer email espace client'}
                        </button>
                        {reservation?.client_email_sent && reservation?.client_email_sent_at && (
                          <p style={{ fontSize: 11, color: colors.neutral, margin: "4px 0 0" }}>
                            Envoyé le {new Date(reservation.client_email_sent_at).toLocaleDateString('fr-FR')}
                          </p>
                        )}
                      </>
                    )}
                  </InfoCard>

                  <InfoCard icon={faCreditCard} title="Moyen de paiement">
                    <p style={{ margin: 0 }}>
                      {reservation?.payment_method === "43"
                        ? "Carte de crédit"
                        : "Virement bancaire"}
                    </p>
                  </InfoCard>

                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Radium(Reservation);
